import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

export default function Page404() {
  return (
    <>
      <Helmet>
        <title>Page Not Found : PES Installations Limited</title>
        <meta name="description" content="The page you are looking for could not be found." />
        <meta name="robots" content="noindex" />
        
      </Helmet>
      <main>
        <section className="InnerHead bgthm2" style={{ padding : '55px 0 30px' }}>
          <img loading="lazy" src={require("../../assets/img/img-bg.svg").default} alt="Services" className="imgbg" width="1600" height="453" />
        </section>
        <section className="Sec1 p404">
          <div className="container">
            <div className="text-center">
              <h1 className="display-1 fw-bold text-secondary">404</h1>
              <h5 className='mt-5 text-secondary'>PAGE NOT FOUND</h5>
              <p className='mb-0 text-secondary'>This page you are looking for doesn`t exists or an other error occurred.</p>
              <p className='text-secondary'><Link to="/">Go Back To Home</Link>, or head over to website to choose a new direction.</p>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
